import type { AdMediaType, AdModel } from '../../types/ads';
import { AdFieldStatusEnum, AdFieldVisibilityEnum } from '../../types/enums';
import type {
  PropertyAdEditorEditRequest,
  PropertyAdEditorFormValues,
} from '../../types/propertyAdEditor';

import { mapPropertyAdSourceToEditorForm } from './propertyAdEditorForm';

export const mapPropertyAdToEditorForm = (
  propertyAd: AdModel,
  responsibleDefaultUserId?: string
): PropertyAdEditorFormValues =>
  mapPropertyAdSourceToEditorForm(propertyAd, responsibleDefaultUserId);

interface BuildPropertyAdEditorEditRequestOptions {
  fallbackCreatorId: string;
  fromXml: boolean;
  media: AdMediaType[];
  publishedAt?: string;
  responsibleDefaultUserId?: string;
  status: AdFieldStatusEnum;
  values: PropertyAdEditorFormValues;
}

export const buildPropertyAdEditorEditRequest = ({
  fallbackCreatorId,
  fromXml,
  media,
  publishedAt,
  responsibleDefaultUserId,
  status,
  values,
}: BuildPropertyAdEditorEditRequestOptions): PropertyAdEditorEditRequest => {
  const { addCommission, responsibleUserId, ...formValues } = values;

  return {
    ...formValues,
    addCommission: addCommission === null ? null : String(addCommission),
    creatorId: responsibleUserId ?? responsibleDefaultUserId ?? fallbackCreatorId,
    fromXml,
    propertyAdAnnouncerIds: [],
    propertyAdMedia: media.map((item) => ({ ...item })),
    status,
    visibility: AdFieldVisibilityEnum.Public,
    ...(publishedAt ? { publishedAt } : {}),
  };
};
